import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userBaseURL } from "config/Api.config";
import customNetworHandler from "network/customNetworHandler";
import { EApiMiddlewareMethods } from "network/networkHandler.types";
import { DownloadAppState } from "./downloadAppSlice.types";
import transformBuildData from "../response.trasform";

export const fetchAppInfo = createAsyncThunk(
  "DownloadApp/fetchAppInfo",
  async (
    {
      filters,
    }: {
      filters: any;
    },
    { rejectWithValue }
  ) => {
    try {
      const { platform, type } = filters;
      const request = {
        url: `/v1/app-build?platform=${platform}&type=${type}`,
        method: EApiMiddlewareMethods.GET,
        data: filters
    } as any;
      const { data } = await customNetworHandler(request, userBaseURL);
      const response = {
        data: data, // Replace with actual API call: await customNetworHandler(request, userBaseURL)
        type: type, // Include filters in the response
      };

      return response;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState: DownloadAppState = {
  cards: [],
  loading: false,
  appData: [],
};

const DownloadAppSlice = createSlice({
  name: "DownloadApp",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAppInfo.fulfilled, (state, action) => {
        const { type, data } = action.payload;
        state.loading = false;
        state.appData = transformBuildData(data, type.toUpperCase());
      })
      .addCase(fetchAppInfo.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default DownloadAppSlice.reducer;
